import { CurrencyIcon } from "@workspace/frontend-ui";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import Pill from "../Pill";

type Props = {
  amount: string;
  tone?: "glass" | "soft";
  size?: "md" | "lg" | "xl";
  className?: string;
};

const AmountPill: FC<Props> = ({
  amount,
  tone = "soft",
  size = "md",
  className,
}) => {
  const {
    state: { currency },
  } = useRewardCenter();

  return (
    <Pill tone={tone} size={size} className={className}>
      {currency && <CurrencyIcon currency={currency} />}
      {amount}
    </Pill>
  );
};

export default AmountPill;
